<template>
  <div class="fotWrap">
    <div v-if="showQus" class="fotTxt">
      <h1>Haven't found what you're looking for?</h1>
      <h2>
        Interested in our house & land packages? Enquire to find out more!
      </h2>
      <a :href="link" class="link" target="_Blank">Submit a request</a>
    </div>
    <div class="fotCon">
      <div class="top clear">
        <!--logo-->
        <div
          class="logo"
          v-bind:class="'logoOnWhite-' + tenant"
          @click="toMain"
        ></div>
        <!--share-->
        <div class="share clear">
          <a
            v-if="socialTwitter != null"
            :href="socialTwitter"
            class="twitter"
            target="_blank"
          ></a>
          <a
            v-if="socialFacebook != null"
            :href="socialFacebook"
            class="twitter1"
            target="_blank"
          ></a>
          <a
            v-if="socialInstagram != null"
            :href="socialInstagram"
            class="facebook"
            target="_blank"
          ></a>
        </div>
      </div>
      <div class="bottom">
        <ul class="clear">
          <li class="my_newLi">
            <a :href="urlObj.evtutl" target="_blank">Events</a>
          </li>
          <li class="my_newLi">
            <a :href="urlObj.eduurl" target="_blank">Education</a>
          </li>
          <router-link class="my_newLi" tag="li" to="/faq">FAQ</router-link>
          <router-link class="my_newLi" tag="li" to="/account"
            >Account</router-link
          >
          <router-link class="my_newLi" tag="li" to="/abous"
            >About us</router-link
          >
          <router-link class="my_newLi" tag="li" to="/affiliate"
            ><span @click="refresh('/affiliate')">Affiliated companies</span>
          </router-link>
          <router-link class="my_newLi" tag="li" to="/contact"
            ><span @click="refresh('/contact')">Contact us</span>
          </router-link>
        </ul>
        <p style="padding-bottom:.2rem">
          <router-link tag="strong" to="/term"
            ><i @click="refresh('/term')">Terms & Conditions</i></router-link
          >
          <span>|</span>
          <router-link tag="strong" to="/policy"
            ><i @click="refresh('/policy')">Privacy Policy</i></router-link
          >
        </p>
        <p style="text-decoration:none;">
          team@unifiproperty.com COPYRIGHT 2020
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  inject: ["reload"],
  data() {
    return {
      link: "",
      contactEmail: "",
      contactNumber: "",
      socialInstagram: "",
      socialTwitter: "",
      socialFacebook: "",
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  props: {
    showQus: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  created() {
    // 获取用户详情
    var that = this;
    that.getUserDtl({ callback: that.userCallback });
    that.getSocial({ callback: that.socialCallback });
  },
  methods: {
    ...mapActions("account", ["getUserDtl"]),
    ...mapActions("social", ["getSocial"]),
    refresh(path) {
      if (path == this.$route.path) {
        location.reload();
      }
    },
    // 获取用户详情的回调
    userCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        sessionStorage.removeItem("a");
        sessionStorage.removeItem("b");
        sessionStorage.removeItem("c");
        sessionStorage.removeItem("d");
        sessionStorage.setItem("a", res.data.data.email);
        sessionStorage.setItem("b", res.data.data.phoneNumber);
        sessionStorage.setItem("c", res.data.data.mobileNumber);
        sessionStorage.setItem(
          "d",
          res.data.data.firstName + " " + res.data.data.lastName
        );
        /*if (res.data.data.mobileNumber.slice(0,1) !== '0') {
            res.data.data.mobileNumber = '0' + res.data.data.mobileNumber
        }*/
        that.link =
          "mailto:team@unifiproperty.com?subject=<Submit Request Form>&body=Referrer's name: " +
          res.data.data.firstName +
          " " +
          res.data.data.lastName +
          "%0d%0a" +
          "Referrer's email address: " +
          res.data.data.email +
          "%0d%0a" +
          "Referrer's contact number: " +
          res.data.data.phoneNumber +
          "%0d%0a" +
          "Referrer's mobile number: " +
          res.data.data.mobileNumber +
          "%0d%0a" +
          "========================================" +
          "%0d%0a" +
          "PLEASE ENTER THE PROPERTY DETAILS BELOW AS APPLICABLE:" +
          "%0d%0a" +
          "Desired Suburb(s):" +
          "%0d%0a" +
          "Total Budget: $" +
          "%0d%0a" +
          "Land Size:" +
          "%0d%0a" +
          "Land Frontage:" +
          "%0d%0a" +
          "No. of Bedrooms:" +
          "%0d%0a" +
          "No. of Bathrooms:" +
          "%0d%0a" +
          "Garage:" +
          "%0d%0a" +
          "No. of Living Areas:" +
          "%0d%0a" +
          "Single/Double Story:" +
          "%0d%0a" +
          "Alfresco (Yes/No):" +
          "%0d%0a" +
          "Additional Notes:" +
          "%0d%0a" +
          "Thank you for submitting your request. A Unifi representative will review your request and be in touch within the next 24 - 48 hours." +
          " %0d%0a ";
        that.link = that.link.replace(
          " UNIFI ",
          " " + that.tenant.toUpperCase() + " "
        );
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },

    socialCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        this.socialInstagram = res.data.data.socialInstagram;
        this.socialTwitter = res.data.data.socialTwitter;
        this.socialFacebook = res.data.data.socialFacebook;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
      that.getUserDtl({ callback: that.userCallback });
    },

    toMain() {
      var that = this;
      if (that.$route.path !== "/") {
        that.$router.push("/");
      }
    },
    evt() {
      var v = this.urlLst.find(v => {
        if (v.type == 1) {
          return v;
        }
      });
      if (v) {
        window.open(v.url, "_blank");
      }
    }
  },
  computed: {
    ...mapState({
      urlObj: state => state.login.url
    })
  }
};
</script>

<style lang="scss" scoped>
.fotWrap {
  width: 100%;
  background: #f5f5f7;
}

.fotTxt {
  width: 100%;
  height: 5.68rem;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-image: url("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/files/images/202007tswZY21nGL");
  color: #fff;

  h1 {
    font-size: 0.52rem;
    line-height: 0.78rem;
    padding: 0.7rem 1rem 0 1rem;
    margin-bottom: 0.18rem;
    text-align: center;
    word-break: break-word;
  }

  h2 {
    font-size: 0.32rem;
    line-height: 0.48rem;
    margin-bottom: 0.48rem;
    text-align: center;
    padding: 0 0.64rem;
  }

  .link {
    display: block;
    border: none;
    margin: 0 auto;
    cursor: pointer;
    width: 5.18rem;
    height: 0.92rem;
    background: rgba(44, 202, 115, 1);
    border-radius: 6px;
    text-align: center;
    line-height: 0.92rem;
    font-size: 0.28rem;
    color: #fff;
    font-family: ProximaNova-Semibold;
    text-decoration: none;
  }
}

.fotCon {
  width: 100%;
  margin: 0 auto;
  color: #fff;
  padding: 0 0.32rem;
  box-sizing: border-box;

  .top {
    padding: 0.48rem 0;
    border-bottom: 1px solid #3f3f46;
    margin-bottom: 0.32rem;
  }

  .logo {
    width: 1.72rem;
    height: 0.68rem;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    //background-image: url('../../assets/footer.png');
    float: left;
    cursor: pointer;
  }

  .share {
    float: right;

    .twitter {
      display: block;
      width: 0.65rem;
      height: 0.65rem;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../../assets/t.png");
      float: right;
      cursor: pointer;
    }

    .twitter1 {
      display: block;
      width: 0.65rem;
      height: 0.65rem;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../../assets/1iocn.png");
      float: left;
      cursor: pointer;
      margin-right: 0.2rem;
    }

    .facebook {
      display: block;
      width: 0.65rem;
      height: 0.65rem;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../../assets/f.png");
      float: right;
      margin-right: 0.2rem;
      cursor: pointer;
    }
  }

  .bottom {
    text-align: center;

    ul {
      display: inline-block;
      font-size: 0.32rem;
      width: 100%;
      color: #111111;
      border-bottom: 1px solid #3f3f46;
      padding-bottom: 0.42rem;
      margin-bottom: 0.52rem;

      li {
        font-size: 0.32rem;
        line-height: 0.38rem;
        margin: 0.28rem 0;
        cursor: pointer;

        a {
          color: #111111;
          text-decoration: none;
        }
      }

      li:nth-last-child(1) {
        margin: 0;
      }
    }

    p {
      padding-bottom: 0.52rem;
      font-size: 0.24rem;
      line-height: 0.28rem;
      color: #3f3f46;
      text-align: center;
      text-decoration: underline;
      cursor: pointer;

      span {
        display: inline-block;
        margin: 0 0.25rem;
        text-decoration: none;
      }

      i {
        font-style: normal;
      }

      strong {
        font-weight: normal;
      }
    }
  }
}

.my_newLi {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/package/footer.vue